import React from 'react';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import Logo from '../assets/img/dr-mario-arcila-logo.webp'
import Coolsculpting from '../components/Hardcoded/Coolsculpting'
    

function CoolsculptingPage() {
  return (
    <div>
        <Header logoSrc={Logo}/>
        <Coolsculpting />
        <Footer logoSrc={Logo}/>
    </div>
  );
}

export default CoolsculptingPage;
